'use strict';
import moment from 'moment-timezone';
angular.module('docketbook').
  controller('docketMobileDetailController', function (docketService, orderService, resourceService, addressBookService, userService, $rootScope, $scope, $state, $stateParams, $mdpDatePicker, $mdpTimePicker, $mdToast, $mdBottomSheet, splitListInterface, $http, Restangular, accessControl, uuid, $timeout, scroll, geolocation) {
    mixpanel.track("Opened DocketDetail Mobile");

    /***************************/
    /***** Setup Variables *****/
    /***************************/

    $scope.moment = moment;
    $scope.listItems = [];
    $scope.itemEdit = null;
    $scope.viewState = 'docket';
    $scope.docketLoadingError = null;

    // Last geolocation
    $scope.lastGeolocation = {};
    $scope.lastGeolocationCheck = moment();

    // Data
    $scope.currentUser = accessControl.currentUser();
    $scope.currentOrgGroup = accessControl.currentOrgGroup();
    $scope.currentOrg = accessControl.currentOrg();
    $scope.assignDocket = { organisations: [], selected: [] };
    $scope.fullApiPath = DOCKETBOOK_API_URL + "/" + $scope.urlVersion;

    /**********************/
    /**** Permissions *****/
    /**********************/

    $scope.userHasPermission = function (permissionName) {
      return accessControl.userHasPermission(permissionName);
    }

    $scope.userCanDoAction = userService.userCanDoAction;

    /***************************************/
    /***** Docket Detail View Controls *****/
    /***************************************/

    $scope.openDocketMobile = function (docket, openingTab) {
      $scope.docketLoadingError = null;
      $scope.viewState = 'docket';
      $scope.prepareForDocketFromParent(docket);
      docketService.getDocket(docket, true, function (docketFull) {
        $scope.lastCleanDocket = angular.copy(docketFull);
        $scope.loadDocketFromParent(docketFull, openingTab);
      }, function (err) {
        $scope.docketLoadingErrorFull = err;
        $scope.docketLoadingError = "Error Loading Docket";
      });
    }

    $scope.newDocket = function (fromType, fromId) {
      $scope.docketLoadingError = null;
      $scope.viewState = 'docket';
      $scope.prepareForDocketFromParent();
      $scope.newDocketFromParent(fromType, fromId, function (newDocket) {
        if (newDocket.id != null && $scope.currentOrg != null && $scope.currentOrgGroup != null) {
          $state.go('main.groupDocketDetail', { docketId: newDocket.id, orgId: $scope.currentOrg.id, groupId: $scope.currentOrgGroup.id });
        } else if (newDocket.id != null) {
          $state.go('main.docketDetail', { docketId: newDocket.id });
        } else {
          $scope.openNewDocketFromParent(newDocket);
        }
      });
    }

    $scope.closeDocket = function () {
      var stateBack = {};
      if ($stateParams.stateTrail && $stateParams.stateTrail.length > 0) {
        stateBack = $stateParams.stateTrail[$stateParams.stateTrail.length - 1];
      }
      var justGoToBasic = false;
      if (stateBack.name == 'main.groupDocketDetail' && stateBack.docketId == 'new') {
        if ($stateParams.stateTrail[$stateParams.stateTrail.length - 2]) {
          stateBack = $stateParams.stateTrail[$stateParams.stateTrail.length - 2];
        } else {
          justGoToBasic = true;
        }
      }

      var stateOptions = {};
      if (stateBack.orderId) {
        stateOptions.orderId = stateBack.orderId;
      }
      if (stateBack.jobId) {
        stateOptions.jobId = stateBack.jobId;
      }
      if (stateBack.docketId) {
        stateOptions.docketId = stateBack.docketId;
      }
      if (stateBack.fromTab) {
        stateOptions.openTab = stateBack.fromTab;
      }
      if (stateBack.orgId) {
        stateOptions.orgId = stateBack.orgId;
      }
      if (stateBack.groupId) {
        stateOptions.groupId = stateBack.groupId;
      }
      if (justGoToBasic) {
        $state.go('main.groupDockets', stateOptions);
      } else if (stateBack.name) {
        $state.go(stateBack.name, stateOptions);
      } else {
        if ($scope.currentOrg != null) {
          $state.go('main.groupDockets', { orgId: $scope.currentOrg.id, groupId: $scope.currentOrgGroup.id });
        } else {
          $state.go('main.dockets');
        }
      }
    }

    $scope.saveAndStay = function (docket) {
      var newDocket = false;
      if (docket.id == null) {
        newDocket = true;
      }
      if (!$scope.progressiveSaveInProcess) {
        docket.loading = true;
        docket.loadingType = "saving";

        // get diff of docket
        if (docket.id != null) {
          docketService.getDiffedDocket($scope.lastCleanDocket, docket, null, function (diffedDocket, diffCount) {
            docketService.saveDocket(diffedDocket, function (docketUpdated) {
              $scope.showToast('Docket Changes Saved');
              $scope.openDocketMobile(docketUpdated.id, $scope.currentActiveTab());
            }, function (err) {
              docket.loading = false;
              $scope.alertService.presentAutoAlert('saveDocket', err);
            });
          });
        } else {
          docketService.saveDocket(docket, function (docketUpdated) {
            $scope.showToast('New Docket Saved');
            if ($scope.currentOrg != null) {
              $state.go('main.groupDocketDetail', { orgId: $scope.currentOrg.id, groupId: $scope.currentOrgGroup.id, docketId: docketUpdated.id });
            } else {
              $state.go('main.docketDetail', { docketId: docketUpdated.id });
            }
            //$scope.openDocketMobile(docketUpdated.id, $scope.currentActiveTab());
          }, function (err) {
            docket.loading = false;
            $scope.alertService.presentAutoAlert('saveDocket', err);
          });
        }
      }
    }

    $scope.closeWithoutSave = function (docket) {
      // check if there are any changes first
      if (docket.id == null) {
        // new dockets arent checked for their diff - because their wont be one
        $scope.closeDocket();
        return;
      }

      docketService.getDiffedDocket($scope.lastCleanDocket, docket, 'tab', function (diffedDocket, diffCount) {
        if (diffCount > 0) {
          var buttonActions = [{ title: 'Save', action: 'save', colour: 'green' }, { title: "Don't Save", action: 'dontSave', colour: 'red' }, { title: "Cancel", action: 'cancel', colour: 'grey' }];
          $scope.alertService.presentConfirmAlert('Unsaved Changes', 'Would you like to save changes before exiting?', buttonActions, function (actionSelected) {
            if (actionSelected == 'save') {
              docketService.saveDocket(diffedDocket, function (docketUpdated) {
                $scope.closeDocket();
              })
            } else if (actionSelected == 'dontSave') {
              $scope.closeDocket();
            } else {
              // do nothing - stay where we are
            }
          });
        } else {
          $scope.closeDocket();
        }
      });
    }

    /**************************/
    /***** Docket Actions *****/
    /**************************/

    $scope.deleteDocket = function (docket) {
      docketService.deleteDocket(docket, function () {
        $scope.closeDocket();
      }, function (err) {
        $scope.alertService.presentAutoAlert('deleteDocket', err);
      });
    }

    $scope.sendDocket = function (docket) {
      docket.loading = true;
      docket.loadingType = "saving";
      $mdBottomSheet.hide();
      docketService.validateDocket(docket, function () {
        // Docket has been validated to be ok - continue with save/send
        docketService.sendDocket($scope.lastCleanDocket, docket, function (docketUpdated) {
          $scope.openDocketMobile(docketUpdated.id);
        }, function (err) {
          docket.loading = false;
          $scope.alertService.presentAutoAlert('sendDocket', err);
        });
      }, function (errors) {
        docket.loading = false;
        var reasons = [];
        for (var i = 0; i < errors.length; i++) {
          reasons.push(errors[i].name);
        }
        $scope.alertService.presentAutoValidationAlert('sendDocket', reasons);
      });
    }

    $scope.acceptDocket = function (docket) {
      docket.loading = true;
      docket.loadingType = "saving";
      $mdBottomSheet.hide();
      docketService.acceptDocket(docket, function (docketUpdated) {
        docket.loading = false;
        $scope.openDocketMobile(docketUpdated.id);
      }, function (err) {
        docket.loading = false;
        $scope.alertService.presentAutoAlert('acceptDocket', err);
      });
    }

    $scope.reDraftDocket = function (docket) {
      docket.loading = true;
      docket.loadingType = "saving";
      $mdBottomSheet.hide();
      docketService.reDraftDocket(docket, function (docketUpdated) {
        docket.loading = false;
        $scope.openDocketMobile(docketUpdated.id);
      }, function (err) {
        docket.loading = false;
        $scope.showToast('Error Re-Drafting Docket');
      });
    }

    $scope.rejectDocket = function (docket) {
      docket.loading = true;
      docket.loadingType = 'saving';
      $mdBottomSheet.hide();
      swal({
        title: "Reject Docket " + docket.docketNumber,
        text: "Please provide a reason for rejecting this docket.",
        type: "input",
        showCancelButton: true,
        closeOnConfirm: true,
        inputPlaceholder: "Reason"
      }, function (inputValue) {
        if (inputValue === false) {
          return;
        }

        docketService.rejectDocket(docket, inputValue, function (docketUpdated) {
          docket.loading = false;
          $scope.openDocketMobile(docketUpdated.id);
        }, function (err) {
          docket.loading = false;
          $scope.alertService.presentAutoAlert('rejectDocket', err);
        });
      });
    }

    $scope.downloadDocket = function (docket) {
      var url = '/v1/organisations/' + $scope.currentOrg.id + '/groups/' + $scope.currentOrgGroup.id + '/dockets/' + docket.id + '/downloadpdf';
      window.open(url, "_blank");
    }

    $scope.acceptAndFileDocket = function (docket) {
      docket.loading = true;
      docket.loadingType = "saving";
      $mdBottomSheet.hide();
      docketService.acceptDocket(docket, function (docketUpdated) {
        docket.loading = false;
        $state.go('main.groupFilingDetail', { orgId: $scope.currentOrg.id, groupId: $scope.currentOrgGroup.id, docketId: docketUpdated.id });
      }, function (err) {
        docket.loading = false;
        $scope.alertService.presentAutoAlert('acceptDocket', err);
      });
    }

    /*****************************/
    /**** Progressive Saving *****/
    /*****************************/

    // Update docket after progressive save - IE add ID's to things that were new
    $scope.progressiveDocketUpdate = function (docket, updatedDocket) {
      // replace resources with new resources
      if (updatedDocket.resources != null) {
        docket.resources = updatedDocket.resources;
        $scope.resourcesSaveInProcess = false;
      } else {
        $scope.resourcesSaveInProcess = false;
      }
      $scope.lastCleanDocket = angular.copy(docket);

      if (docket.resources != null) {
        for (var i = 0; i < docket.resources.length; i++) {
          if (docket.resources[i].interactions != null) {
            for (var j = 0; j < docket.resources[i].interactions.length; j++) {
              if (docket.resources[i].interactions[j].interactionTemplate.fields) {
                for (var k = 0; k < docket.resources[i].interactions[j].interactionTemplate.fields.length; k++) {
                  var field = docket.resources[i].interactions[j].interactionTemplate.fields[k];
                  if (field.type == 'date') {
                    docket.resources[i].interactions[j].customFields[field.id] = moment(docket.resources[i].interactions[j].customFields[field.id]).toDate();
                  }
                }
              }
            }
          }
        }
      }
    }

    // Detect any changes and save in background
    $scope.progressiveSaveDocket = function (docket, method) {
      if (!method) {
        method = 'tab';
      }
      if (!$scope.progressiveSaveInProcess && docket && docket.id != null) {
        $scope.backgroundLoadCount += 1;
        $scope.progressiveSaveInProcess = true;
        $scope.resourcesSaveInProcess = true;

        var cleanDocketBefore = angular.copy(Restangular.stripRestangular(docket));
        var docketBefore = angular.copy(Restangular.stripRestangular(docket));

        // Determine what has changed
        docketService.getDiffedDocket($scope.lastCleanDocket, docketBefore, method, function (diffedDocket, diffCount) {
          // Now save the diffed docket
          if (diffCount > 0) {
            docketService.saveDocket(diffedDocket, function (updatedDocket) {
              // Reset lastCleanDocket to be the modifed version that we just saved
              $scope.lastCleanDocket = cleanDocketBefore;
              $scope.progressiveDocketUpdate(docket, updatedDocket);
              $scope.progressiveSaveInProcess = false;
              $scope.resourcesSaveInProcess = false;
              $scope.backgroundLoadCount = 0;
              $scope.showToast('Docket Changes Saved');
            }, function (err) {
              $scope.progressiveSaveInProcess = false;
              $scope.resourcesSaveInProcess = false;
              $scope.backgroundLoadCount = 0;
              $scope.showToast('Background Save Failed');
            });
          } else {
            $scope.progressiveSaveInProcess = false;
            $scope.resourcesSaveInProcess = false;
            $scope.backgroundLoadCount = 0;
          }
        });
      }
    }

    /********************************/
    /***** MAIN OPENING CONTROLS ****/
    /********************************/

    // Parameter controls
    $scope.detailControllerReady = function () {
      $scope.assignDocket = { organisations: [], selected: [] };
      $scope.assignDocket.organisations = accessControl.allowedOrganisations();
      if ($stateParams.docketId != null) {
        if ($stateParams.docketId == 'new') {
          if ($stateParams.fromJob != null) {
            $scope.newDocket('job', $stateParams.fromJob);
          } else if ($stateParams.fromOrder != null) {
            $scope.newDocket('order', $stateParams.fromOrder);
          } else {
            $scope.newDocket();
          }
        } else {
          $scope.openDocketMobile($stateParams.docketId);
        }
      }
    }

    /******************************/
    /***** List View Controls *****/
    /******************************/

    $scope.showDocketDetail = function () {
      $scope.viewState = 'docket';
    }

    $scope.selectContactForDocket = function (docket, companyType, cb) {
      $scope.viewState = 'company';
      $scope.selectCompanyCallback = cb;
      var existingContacts = [];
      var selectedContact = null;
      if (companyType == 'customerContact') {
        if (docket.supplierContact != null) {
          existingContacts.push(docket.supplierContact);
        }
        if (docket.customerContact != null) {
          selectedContact = docket.customerContact;
        }
      } else if (companyType == 'supplierContact') {
        if (docket.customerContact != null) {
          existingContacts.push(docket.customerContact);
        }
        if (docket.supplierContact != null) {
          selectedContact = docket.supplierContact;
        }
      }
      $scope.selectCompanyType = companyType;

      $scope.contactSelectFromParent(existingContacts, selectedContact, function (companySelected) {
        $scope.selectCompanyCallback(companySelected);
        $scope.showDocketDetail();
      });
    }

    $scope.selectContactForShare = function (cb) {
      $scope.viewState = 'company';
      $scope.contactSelectFromParent(null, null, function (companySelected) {
        cb(companySelected);
        $scope.showDocketDetail();
      });
    }

    $scope.selectOrderForDocket = function (options, cb) {
      $scope.viewState = 'order';
      $scope.selectOrderCallback = cb;
      $scope.orderSelectFromParent(options, function (orderSelected) {
        $scope.selectOrderCallback(orderSelected);
        $scope.showDocketDetail();
      });
    }

    $scope.selectTemplateForDocket = function (currentTemplate, cb) {
      $scope.viewState = 'docketTemplate';
      $scope.selectTemplateCallback = cb;
      $scope.templateSelectFromParent(currentTemplate, function (templateSelected) {
        $scope.selectTemplateCallback(templateSelected);
        $scope.showDocketDetail();
      });
    }

    $scope.selectOrganisationForDocket = function (docket, cb) {
      $scope.viewState = 'organisation';
      $scope.selectOrganisationCallback = cb;
      $scope.assignDocket = { selected: [] };
      $scope.assignDocket.organisations = accessControl.allowedOrganisations();
    }

    $scope.cancelSelectOrganisation = function () {
      $scope.showDocketDetail();
      $scope.selectOrganisationCallback(null);
    }

    $scope.selectOrganisationContinue = function (group) {
      $scope.showDocketDetail();
      $scope.selectOrganisationCallback(group);
    }

    $scope.selectResourceForDocket = function (docket, cb) {
      $scope.viewState = 'resource';
      $scope.selectResourceCallback = cb;

      // Get list of available categories
      var categories = {};
      for (var i = 0; i < docket.template.interactionTemplates.length; i++) {
        var interactionTemplate = docket.template.interactionTemplates[i];
        for (var j = 0; j < interactionTemplate.actorCategories.length; j++) {
          if (categories[interactionTemplate.actorCategories[j].id] == null) {
            categories[interactionTemplate.actorCategories[j].id] = interactionTemplate.actorCategories[j];
            categories[interactionTemplate.actorCategories[j].id].filterByOrder = false;
          }
          // Check if resources in category are to be filtered by order or not
          if (categories[interactionTemplate.actorCategories[j].id].filterByOrder == true &&
            interactionTemplate.actorFromOrder != true) {
            categories[interactionTemplate.actorCategories[j].id].filterByOrder = false;
          } else if (categories[interactionTemplate.actorCategories[j].id].filterByOrder != true &&
            interactionTemplate.actorFromOrder == true) {
            categories[interactionTemplate.actorCategories[j].id].filterByOrder = true;
          }
        }
      }

      // convert categories dict to array
      var categoriesArray = [];
      var keys = Object.keys(categories);
      for (var i = 0; i < keys.length; i++) {
        categoriesArray.push(categories[keys[i]]);
      }

      var lineItems = [];
      // Get list of line items from job/order that are to be filtered against
      if (docket.jobRef != null && docket.jobRef.lineItems != null) {
        lineItems = docket.jobRef.lineItems;
      } else if (docket.orderRef != null && docket.orderRef.lineItems != null) {
        lineItems = docket.orderRef.lineItems;
      }

      var options = { categoriesList: categoriesArray, lineItems: lineItems, docketResources: docket.resources };

      $scope.resourceSelectFromParent(options, function (resourceSelected) {
        $scope.selectResourceCallback(resourceSelected);
        $scope.showDocketDetail();
      });
    }

    /**************************/
    /***** Modal Controls *****/
    /**************************/

    $scope.newInteractionForResource = function (docket, resource, cb) {
      $scope.newInteractionCallback = cb;
      $scope.newInteractionFromParent(docket, resource, function (interaction) {
        $scope.newInteractionCallback(interaction);
      });
    }

    $scope.editInteractionForResource = function (interaction, docket, resource, cb) {
      $scope.editInteractionCallback = cb;
      $scope.editInteractionFromParent(docket, interaction, resource, function (interaction) {
        $scope.editInteractionCallback(interaction);
      });
    }

    $scope.captureSignatureForDocket = function (entity, nameRequired, name, terms, template, cb) {
      $scope.captureSignatureCallback = cb;
      $scope.captureSignatureFromParent(entity, nameRequired, name, terms, template, function (signatureObject) {
        $scope.captureSignatureCallback(signatureObject);
      });
    }

    $scope.editChecklistForDocket = function (checklistsData, checklist, cb) {
      $scope.checklistCallback = cb;
      $scope.openChecklistFromParent(checklistsData, checklist, function (checklistReturned) {
        $scope.checklistCallback(checklistReturned);
      });
    }

    /******************/
    /***** Toasts *****/
    /******************/

    $scope.showToast = function (message) {
      var toast = {};
      if ($stateParams.device == 'desktop') {
        toast = $mdToast.simple()
          .textContent(message)
          .position('top right')
          .hideDelay(3000);
      } else {
        toast = $mdToast.simple()
          .textContent(message)
          .position('top right')
          .hideDelay(3000)
          .capsule(false)
          .parent(document.querySelectorAll('#toasterInner'));
      }
      $mdToast.show(toast).then();
    }

    /***********************************/
    /***** Last geolocation helper *****/
    /***********************************/

    var timeoutPromise = null;

    $scope.updateGeolocation = function () {
      var getLocation = false;
      var minutesElapsed = moment.duration(moment().diff($scope.lastGeolocationCheck)).asMinutes();
      if (minutesElapsed > 2) {
        getLocation = true;
      } else {
        getLocation = false;
      }
      if (getLocation) {
        navigator.geolocation.getCurrentPosition(function (data) {
          $scope.lastGeolocation = { lat: data.coords.latitude, long: data.coords.longitude, time: moment() };
          $scope.lastGeolocationCheck = moment();
          timeoutPromise = $timeout(function () {
            $scope.updateGeolocation();
          }, 10000);
        }, function (err) {
          $scope.lastGeolocationCheck = moment();
          timeoutPromise = $timeout(function () {
            $scope.updateGeolocation();
          }, 10000);
        });
      } else {
        timeoutPromise = $timeout(function () {
          $scope.updateGeolocation();
        }, 10000);
      }
    }

    $scope.updateGeolocation();

    $scope.$on('$destroy', function () {
      $timeout.cancel(timeoutPromise);
    });
  });



// WEBPACK FOOTER //
// ./src/controllers/dockets/mobileDetailController.js